import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FuelcardService } from '../../vdms_core/services/api/fuelcard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AwsService } from '../../../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-add-fuel-card-credit',
  templateUrl: './add-fuel-card-credit.component.html',
  styleUrls: ['./add-fuel-card-credit.component.css']
})
export class AddFuelCardCreditComponent implements OnInit {

  fuelCardCreditForm: FormGroup;
  rnNumberList: any = [];
  fuelCardNoList: any = [];

  screenType: string = 'add';
  editData: any;
  constructor(
    private fb: FormBuilder,
    private spinnerService: Ng4LoadingSpinnerService,
    private fuelCardService: FuelcardService,
    private router: Router,
    public awserviceProvider: AwsService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.route.params.subscribe(params => {
      if (params.type) {
        this.screenType = params.type;
        if (this.screenType === 'edit') {
          this.fuelCardService.fuelCardCreditData.subscribe((data: any) => {
            if (data) {
              this.editData = data;
              this.fuelCardCreditForm.patchValue({
                userName: data.rn_number,
                loadingValue: data.loading_value,
                loadingDate: data.loading_date
              });
            } else {
              this.screenType = 'add';
            }
          });
        }
      } else {
        this.screenType = 'add';
      }
    });
  }

  initializeForm() {
    this.fuelCardCreditForm = this.fb.group({
      userName: new FormControl('', Validators.required),
      loadingValue: new FormControl('', Validators.required),
      loadingDate: new FormControl('', Validators.required)
    });
  }

  async savefuelCardCredit() {
    if (this.screenType === 'edit') {
      this.spinnerService.show();
      let formValue = this.fuelCardCreditForm.getRawValue();
      let payload = {
        id: this.editData.id,
        rn_number: formValue.userName,
        rnc_user_id: this.editData.user.id,
        fuel_card_id: this.editData.fuel_card_id,
        loading_value: String(formValue.loadingValue),
        loading_date: formValue.loadingDate
      }
      const fuelCredit = await this.fuelCardService.updateFuelCardCredit(payload);
      if (fuelCredit) {
        this.spinnerService.hide();
        this.navigateBack();
      } else {
        this.spinnerService.hide();
        console.log("something went to wrong to update FuelCardCredit :::::::");
        alert(`something went to wrong to update FuelCardCredit:::`);
      }
    } else {
      this.spinnerService.show();
      const userData = await this.awserviceProvider.findUserByUserName(this.fuelCardCreditForm.value.userName);
      if (userData.length) {
        const assignedCar = await this.awserviceProvider.filterRnExistCar(this.fuelCardCreditForm.value.userName);
        const fuelcard = assignedCar.find(car => car.status === 'ASSIGN' && car.fuel_card_id && String(car.ex_data || '').toLowerCase().includes('office'));

        if (assignedCar.length && fuelcard) {
          let formValue = this.fuelCardCreditForm.getRawValue();

          let payload = {
            fuel_card_id: fuelcard.fuel_card_id,
            rn_number: formValue.userName,
            rnc_user_id: userData[0].id,
            loading_value: String(formValue.loadingValue),
            loading_date: formValue.loadingDate,
            email: userData[0].email_address
          }

          const fuelCredit: any = await this.fuelCardService.createFuelCardCredit(payload);
          let getcardNumber: any;
          if (fuelCredit && fuelCredit.fuel_card_id) {
            getcardNumber = await this.fuelCardService.findFuelCardByCardId(fuelCredit.fuel_card_id);
          }

          if (fuelCredit) {
            this.spinnerService.hide();
            payload['rnc_user_name'] = userData[0].name;
            if (getcardNumber && getcardNumber.length > 0 && getcardNumber[0].card_number) {
              payload['fuel_card_no'] = getcardNumber[0].card_number;
            } else {
              payload['fuel_card_no'] = '';
            }
            this.triggerEmail(payload);
          } else {
            this.spinnerService.hide();
            console.log("something went to wrong to create FuelCardCredit :::::::");
            alert(`something went to wrong to create FuelCardCredit:::`);
          }
        } else {
          this.spinnerService.hide();
          console.log("Fuel Card Not Assigned for This Employee :::::::");
          alert(`Fuel Card Not Assigned for This Employee::: ${this.fuelCardCreditForm.value.userName}`);
        }
      } else {
        this.spinnerService.hide();
        console.log("User Not Found :::::::", this.fuelCardCreditForm.value.userName);
        alert(`Employee Not Found::: ${this.fuelCardCreditForm.value.userName}`);
      }
    }
  }

  triggerEmail(payload: any) {
    this.fuelCardService.triggercreditEmail(payload);
    this.navigateBack();
  }

  navigateBack() {
    this.router.navigate(['/pages/fuel-card-credit']);
  }

}
